import './register.scss';
import React from 'react';
import { Translate, translate, getUrlParameter, Storage } from 'react-jhipster';
import { Row, Col, Button, UncontrolledTooltip } from 'reactstrap';
import { AUTHORIZE_SMART_CA, ENP, IND, KEY_STORAGE, LINK_INTRODUCE_SMART_CA, ORG, Rester_Type, SUCCESS } from 'app/config/constants';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import HomeNetworkModal from './homeNetwork-modal';
import { handleGetIDP, signHashSmartCA } from './register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import ModalSmartCA from './smart-ca/modal-smart-ca';
import RegisterBottom from './registerBottom';

export interface IRegisterHomeProps extends StateProps, DispatchProps, RouteComponentProps {}
export interface IRegisterHomeState {
  value: string;
  redirectUrl: string;
  typeReg: string;
  showModal: boolean;
  typePhone: string;
  showModalWaittingSmartCA: boolean;
  messageSignHashSmartCA: string;
  toolTipOpen: boolean;
}

export class RegisterHome extends React.Component<IRegisterHomeProps, IRegisterHomeState> {
  state: IRegisterHomeState = {
    value: IND,
    redirectUrl: '',
    typeReg: '',
    showModal: false,
    typePhone: '',
    showModalWaittingSmartCA: false,
    messageSignHashSmartCA: '',
    toolTipOpen: false
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.signHashSmartCAFail) {
      // time out
      this.sighHashError('Có lỗi xảy ra trong quá trình ký số, Vui lòng thử lại!');
    }
    if (this.props.responseSignSmartCA !== nextProps.responseSignSmartCA) {
      const { responseSignSmartCA } = nextProps;
      if (responseSignSmartCA.status === SUCCESS) {
        this.setState({
          showModalWaittingSmartCA: false,
          redirectUrl: '/info/register',
          messageSignHashSmartCA: ''
        });
        Storage.session.set('certInfo', responseSignSmartCA.data);
        Storage.session.set('type', 'SmartCA');
      } else if (responseSignSmartCA.status === 'SMART_CA_SIGN_ERROR') {
        this.sighHashError(responseSignSmartCA.message);
      } else {
        this.sighHashError('Có lỗi xảy ra trong quá trình ký số, Vui lòng thử lại!');
      }
    }
  }

  sighHashError = message => {
    Storage.session.remove('userType');
    this.setState({
      messageSignHashSmartCA: message
    });
    setTimeout(() => {
      this.setState({
        showModalWaittingSmartCA: false,
        messageSignHashSmartCA: ''
      });
    }, 4000);
  };

  componentWillMount() {
    // localStorage.setItem(KEY_STORAGE.USER_TYPE, JSON.stringify(this.state.value));
    window['is_mobile']();
  }

  componentDidMount() {
    const code = getUrlParameter('code', this.props.location.search);
    const urlCallback = getUrlParameter('urlCallback', this.props.location.search);
    const clientId = getUrlParameter('clientId', this.props.location.search);
    Storage.session.set('urlCallbackFromSP', urlCallback);
    Storage.session.set('clientIdFromSP', clientId);
    const userType = Storage.session.get('userType');
    const codeSmartCA = Storage.session.get('codeSmartCA');
    if (codeSmartCA !== undefined && code === codeSmartCA) {
      Storage.session.set('userType', this.state.value);
      return;
    }
    if (code) {
      Storage.session.set('codeSmartCA', code);
      if (userType !== undefined) {
        Storage.session.set('userType', userType);
      } else {
        Storage.session.set('userType', this.state.value);
      }
      this.signHashSmartCA(code);
    } else {
      Storage.session.set('userType', this.state.value);
    }
  }

  signHashSmartCA = code => {
    this.setState({ showModalWaittingSmartCA: true });
    this.props.signHashSmartCA(code, this.props.config.redirectUriSmartCA);
  };

  onChanged = userType => {
    this.setState({
      value: userType
    });
    // localStorage.setItem(KEY_STORAGE.USER_TYPE, JSON.stringify(userType));
    Storage.session.set('userType', userType);
  };

  renderRedirect = () => {
    if (this.state.redirectUrl) {
      if (this.state.redirectUrl === '/info/register') {
        return (
          <Redirect
            push
            to={{
              pathname: this.state.redirectUrl
            }}
          />
        );
      } else {
        return (
          <Redirect
            push
            to={{
              pathname: this.state.redirectUrl,
              state: {
                regType: this.state.typeReg,
                userType: this.state.value,
                phoneType: this.state.typePhone
              }
            }}
          />
        );
      }
    }
  };

  setTypeRedirect = (url, type, typePhone?) => {
    this.setState({
      redirectUrl: url,
      typeReg: type,
      typePhone: typePhone ? typePhone : ''
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false
    });
  };

  handleShowModal = type => {
    this.setState({
      showModal: true,
      typeReg: type
    });
  };

  handleSelectHomeNetwork = typePhone => {
    this.setTypeRedirect('/registerDVC', this.state.typeReg, typePhone);
  };

  handleRegisterSmartCA = () => {
    window.location.href =
      this.props.config.urlAuthCodeSmartCA +
      '?response_type=' +
      AUTHORIZE_SMART_CA.code +
      '&redirect_uri=' +
      this.props.config.redirectUriSmartCA +
      '&client_id=' +
      this.props.config.cliendIDSmartCA +
      '&scope=' +
      AUTHORIZE_SMART_CA.scope;
  };
  mouseOver = () => {
    this.setState({
      toolTipOpen: true
    });
  };
  mouseOut = () => {
    this.setState({
      toolTipOpen: false
    });
  };
  invokeIntroduceSmartCA = () => {
    window.open(LINK_INTRODUCE_SMART_CA);
  };
  render() {
    let vnPost = null;
    if (this.props.listIdp && this.props.listIdp.data) {
      vnPost = this.props.listIdp.data.filter(item => item.IdpName.toLowerCase() == 'vn post');
    }
    return (
      <div className="box-register">
        {this.renderRedirect()}
        <ModalSmartCA showModal={this.state.showModalWaittingSmartCA} message={this.state.messageSignHashSmartCA} />
        <HomeNetworkModal showModal={this.state.showModal} handleClose={this.handleClose} handleOnclick={this.handleSelectHomeNetwork} />
        <div className="row">
          <div className="col">
            <h2 className="text-center text-register" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h2>
            <p className="text-center txtContent">Vui lòng chọn phương thức đăng ký</p>
            <div className="rowCheckbox">
              <div className="form-check form-check-inline">
                {this.state.value === IND ? (
                  <img
                    className="form-check-input"
                    id="inlineCheckbox1"
                    src={require('app/images/checkbox_Select.png')}
                    alt=""
                    onClick={() => this.onChanged(IND)}
                  />
                ) : (
                  <img
                    className="form-check-input"
                    id="inlineCheckbox2"
                    src={require('app/images/checkbox_Normal.png')}
                    alt=""
                    onClick={() => this.onChanged(IND)}
                  />
                )}
                <label className="form-check-label" htmlFor="inlineCheckbox1">
                  CBCCVC
                </label>
              </div>
              <div className="form-check form-check-inline">
                {this.state.value === ORG ? (
                  <img
                    className="form-check-input"
                    id="inlineCheckbox1"
                    src={require('app/images/checkbox_Select.png')}
                    alt=""
                    onClick={() => this.onChanged(ORG)}
                  />
                ) : (
                  <img
                    className="form-check-input"
                    id="inlineCheckbox2"
                    src={require('app/images/checkbox_Normal.png')}
                    alt=""
                    onClick={() => this.onChanged(ORG)}
                  />
                )}
                <label className="form-check-label" htmlFor="inlineCheckbox2">
                  Tổ chức
                </label>
              </div>
            </div>
          </div>
        </div>
        {window['isMobile'] ? null : <div className="row" style={{ justifyContent: 'center' }} />}

        {this.state.value === IND ? (
          <div>
            <div className="backgroundRow row" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.THUE_BAO_DI_DONG)}>
              <img src={require('app/images/taikhoanmatkhau.png')} alt="" />
              <span>Đăng ký bằng tài khoản/mật khẩu</span>
            </div>
            <div className="backgroundRow" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.USB_KY_SO)}>
              <img src={require('app/images/usbkyso.png')} alt="" />
              <span>Tài khoản Token Ban cơ yếu</span>
            </div>
            <div className="backgroundRow row" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.EMAIL)}>
              <img src={require('app/images/taikhoanemail.png')} alt="" />
              <span>Đăng ký bằng email</span>
            </div>
            <div className="backgroundRow row" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.MOBILE)}>
              <img src={require('app/images/taikhoansdt.png')} alt="" />
              <span>Đăng ký bằng số điện thoại</span>
            </div>
          </div>
        ) : (
          <div>
            <div className="backgroundRow" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.THUE_BAO_DI_DONG)}>
              <img src={require('app/images/taikhoanmatkhau.png')} alt="" />
              <span>Tài khoản cấp bởi hệ thống</span>
            </div>
            <div className="backgroundRow" onClick={() => this.setTypeRedirect('/registerDVC', Rester_Type.USB_KY_SO)}>
              <img src={require('app/images/usbkyso.png')} alt="" />
              <span>Tài khoản Token Ban cơ yếu</span>
            </div>
          </div>
        )}
        <div style={{ marginTop: '10px' }}>
          <RegisterBottom isInsurance={true} />
        </div>
      </div>
    );
  }
}

const mapStateToPops = (storeState: IRootState) => ({
  listIdp: storeState.register.idp,
  responseSignSmartCA: storeState.register.responseSignHashSmartCA,
  signHashSmartCAFail: storeState.register.signHashSmartCAFails,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = { handleGetIDP, signHashSmartCA };

type StateProps = ReturnType<typeof mapStateToPops>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToPops,
  mapDispatchToProps
)(RegisterHome);
